import { render, staticRenderFns } from "./join-us.vue?vue&type=template&id=4ce13c7f&scoped=true"
var script = {}
import style0 from "./join-us.vue?vue&type=style&index=0&id=4ce13c7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce13c7f",
  null
  
)

export default component.exports